import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useRef } from 'react';
import { Transition } from 'react-transition-group';
import { animationDuration, defaultStyle, transitionStyles, } from './Expansion.style.js';
export function ExpansionTransition({ in: inProp, children, width, onExited, }) {
    const nodeRef = useRef(null);
    return (_jsx(Transition, { nodeRef: nodeRef, in: inProp, timeout: animationDuration, onExited: onExited, mountOnEnter: true, unmountOnExit: true, children: (state) => {
            return (_jsx(Box, { ref: nodeRef, style: {
                    ...defaultStyle,
                    ...transitionStyles[state],
                    width,
                }, children: children }));
        } }));
}
//# sourceMappingURL=ExpansionTransition.js.map